import { Link } from 'react-router-dom';

const HELPLINE = '0800 006 008';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-surface-2 mt-auto">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Brand */}
          <div>
            <p className="font-heading font-bold text-primary text-lg">🎯 My Bets</p>
            <p className="text-sm text-text-muted mt-1">
              AI-assisted sports betting for South Africa
            </p>
          </div>

          {/* Product nav */}
          <nav className="flex flex-wrap gap-4 text-sm text-text-secondary">
            <Link to="/" className="hover:text-primary transition-colors">Matches</Link>
            <Link to="/bets" className="hover:text-primary transition-colors">My Bets</Link>
            <Link to="/wallet" className="hover:text-primary transition-colors">Wallet</Link>
            <Link to="/account" className="hover:text-primary transition-colors">Account</Link>
            <Link to="/support" className="hover:text-primary transition-colors">Help &amp; Support</Link>
          </nav>
        </div>

        {/* Legal / trust nav */}
        <nav
          className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm text-text-secondary"
          aria-label="Legal and trust"
        >
          <Link to="/responsible-gambling" className="hover:text-primary transition-colors">
            Responsible Gambling
          </Link>
          <Link to="/terms" className="hover:text-primary transition-colors">
            Terms &amp; Betting Rules
          </Link>
          <Link to="/betting-rules" className="hover:text-primary transition-colors">
            Betting Rules
          </Link>
          <Link to="/privacy" className="hover:text-primary transition-colors">
            Privacy (POPIA)
          </Link>
          <Link to="/complaints" className="hover:text-primary transition-colors">
            Complaints
          </Link>
          <Link to="/about" className="hover:text-primary transition-colors">
            About
          </Link>
        </nav>

        {/* Persistent 18+ / responsible-gambling strip */}
        <div className="mt-6 rounded-card border border-warning/30 bg-warning/5 px-4 py-3">
          <p className="text-sm text-text-secondary">
            <strong className="text-text-primary">18+ Only</strong>
            {' · '}
            <strong className="text-text-primary">Bet responsibly</strong>
            {' · '}
            Responsible Gambling Helpline:{' '}
            <a
              href={`tel:${HELPLINE.replace(/\s/g, '')}`}
              className="font-semibold text-warning hover:underline"
            >
              {HELPLINE}
            </a>{' '}
            — free, confidential, 24/7. Gambling can be addictive.
          </p>
        </div>

        {/* Operator / licence line */}
        <p className="mt-6 text-xs leading-relaxed text-text-muted">
          My Bets is operated by Marome Investments (Pty) Ltd. Licensed bookmaker —
          licence details pending.
        </p>
        <p className="mt-2 text-xs text-text-muted">
          © {new Date().getFullYear()} My Bets / Marome Investments (Pty) Ltd. All rights
          reserved. Betting is for adults 18+. Please gamble responsibly.
        </p>
      </div>
    </footer>
  );
}
